<script setup>
defineProps({
  fieldModel: Object,
  disabled: Boolean
})
</script>

<template>
  <input
    type="checkbox"
    v-model="fieldModel.inputValue"
    :true-value="true"
    :false-value="false"
    :disabled="disabled || !fieldModel.editable"
    :class="{ 'is-invalid': fieldModel.hasErrors }"
  />
</template>
